"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var PanelBase_1 = require("../Panel/PanelBase");
var monitoring_1 = require("../../services/monitoring");
var Sheet = /** @class */ (function (_super) {
    __extends(Sheet, _super);
    function Sheet(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRequestClose = function (event) {
            if (_this.props.onRequestClose) {
                _this.props.onRequestClose(event, false);
            }
        };
        _this.getSheetClass = function () {
            // If there's already a class created, return
            if (_this.state.lockedScrollingClass) {
                return _this.state.lockedScrollingClass;
            }
            // Check if there are sheets open
            if (document.body.classList.contains('body--no-scroll')) {
                // iterate until we find an unused number
                var index = 2;
                while (document.body.classList.contains('sheet-' + index)) {
                    index++;
                }
                return 'sheet-' + index;
            }
            else {
                return 'sheet-1';
            }
        };
        _this.state = {
            lockedScrollingClass: ''
        };
        return _this;
    }
    Sheet.prototype.componentDidMount = function () {
        monitoring_1.default('sheet');
    };
    Sheet.prototype.componentWillReceiveProps = function (newProps) {
        // If open prop changes, toggle windowscroll
        if (this.props.open !== newProps.open) {
            this.toggleWindowScroll(newProps);
        }
    };
    Sheet.prototype.render = function () {
        var _a = this.props, className = _a.className, open = _a.open, overlaid = _a.overlaid;
        var cls = classNames('sheet', className, {
            'sheet--current': open,
            'sheet--overlaid': overlaid
        });
        return (React.createElement(PanelBase_1.default, __assign({ type: "sheet" }, this.props, { className: cls, onRequestClose: this.handleRequestClose })));
    };
    Sheet.prototype.toggleWindowScroll = function (props) {
        // Determine this unique sheet class
        var sheetClass = this.getSheetClass();
        // If the sheet is open
        if (props.open) {
            // Always add the body--no-scroll class
            document.body.classList.add('body--no-scroll');
            // Always add this sheet's class
            document.body.classList.add(sheetClass);
            // Save the sheet class to state
            this.setState({ lockedScrollingClass: sheetClass });
        }
        else {
            // When the sheet is closed
            // Always remove the sheet class
            document.body.classList.remove(sheetClass);
            // Remove the sheet class from state so it's always unique on open
            this.setState({ lockedScrollingClass: '' });
            // Check to see if there are any other sheet classes applied
            var shouldRemoveNoScroll = true;
            for (var i = 0; i < document.body.classList.length; i++) {
                if (/sheet-.*/.test(document.body.classList[i])) {
                    shouldRemoveNoScroll = false;
                }
            }
            // If there aren't any other sheet classes, remove the body--no-scroll class
            if (shouldRemoveNoScroll) {
                document.body.classList.remove('body--no-scroll');
            }
        }
    };
    return Sheet;
}(React.Component));
exports.default = Sheet;
//# sourceMappingURL=Sheet.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Sheet/Sheet.js
// module id = 247
// module chunks = 0